export default "__VITE_ASSET__CwOWuFWU__"